/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseErrors } from './get-evidence200-response-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseFile } from './get-evidence200-response-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseInvoiceIssuer } from './get-evidence200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponsePaymentsInner } from './get-evidence200-response-payments-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseUpdatedBy } from './get-evidence200-response-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseUploadedBy } from './get-evidence200-response-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidence200ResponseWarnings } from './get-evidence200-response-warnings';

/**
 * 
 * @export
 * @interface GetEvidence200Response
 */
export interface GetEvidence200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'id': string;
    /**
     * This is set if the payment type of the evidence is CARD_TRANSACTION. Otherwise, null.
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'paymentType': GetEvidence200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'electronicMethod': GetEvidence200ResponseElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'documentSize': GetEvidence200ResponseDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'legalValidity': GetEvidence200ResponseLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidence200Response
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidence200ResponseFile}
     * @memberof GetEvidence200Response
     */
    'file': GetEvidence200ResponseFile;
    /**
     * 
     * @type {Array<GetEvidence200ResponsePaymentsInner>}
     * @memberof GetEvidence200Response
     */
    'payments': Array<GetEvidence200ResponsePaymentsInner>;
    /**
     * 
     * @type {GetEvidence200ResponseInvoiceIssuer}
     * @memberof GetEvidence200Response
     */
    'invoiceIssuer': GetEvidence200ResponseInvoiceIssuer | null;
    /**
     * 
     * @type {GetEvidence200ResponseErrors}
     * @memberof GetEvidence200Response
     */
    'errors': GetEvidence200ResponseErrors;
    /**
     * 
     * @type {GetEvidence200ResponseWarnings}
     * @memberof GetEvidence200Response
     */
    'warnings': GetEvidence200ResponseWarnings;
    /**
     * 
     * @type {GetEvidence200ResponseUpdatedBy}
     * @memberof GetEvidence200Response
     */
    'updatedBy': GetEvidence200ResponseUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidence200ResponseUploadedBy}
     * @memberof GetEvidence200Response
     */
    'uploadedBy': GetEvidence200ResponseUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidence200Response
     */
    'deleted': boolean;
}

export const GetEvidence200ResponsePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidence200ResponsePaymentTypeEnum = typeof GetEvidence200ResponsePaymentTypeEnum[keyof typeof GetEvidence200ResponsePaymentTypeEnum];
export const GetEvidence200ResponseElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseElectronicMethodEnum = typeof GetEvidence200ResponseElectronicMethodEnum[keyof typeof GetEvidence200ResponseElectronicMethodEnum];
export const GetEvidence200ResponseDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseDocumentSizeEnum = typeof GetEvidence200ResponseDocumentSizeEnum[keyof typeof GetEvidence200ResponseDocumentSizeEnum];
export const GetEvidence200ResponseLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidence200ResponseLegalValidityEnum = typeof GetEvidence200ResponseLegalValidityEnum[keyof typeof GetEvidence200ResponseLegalValidityEnum];


